import axios, { AxiosError } from "axios";
import { isAxiosError } from "@/api/api";
import { filterUrl } from "./filterDomain";

export type RequestErrorData = {
  method: string;
  url: string;
  status?: number;
  code?: string;
};

export function isReportableRequestError(error: unknown): error is AxiosError {
  return (
    isAxiosError(error) && error.code !== AxiosError.ERR_CANCELED && error.response?.status !== 401
  );
}

export function toRequestErrorData(error: AxiosError): RequestErrorData {
  const config = error.config;
  return {
    method: config?.method ?? "unknown",
    url: config ? filterUrl(axios.getUri(config)) : "unknown",
    status: error.response?.status,
    code: error.code,
  };
}
